import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { TabLine, Spacer } from 'components/atoms';
import { modifiersType } from 'types';

const TabsLineList = ({ tabs, modifiers, className }) => {
  if (!tabs && tabs.length === 0) return null;
  return (
    <Wrapper className={className}>
      {tabs.map(({
        text, to = null, isActive = false, onClick,
      }, index) => (
        <Spacer left={index === 0 ? null : 'sm'} key={`${to}-${text}`}>
          <TabLine
            to={to}
            isActive={isActive}
            modifiers={modifiers}
            onClick={onClick}
          >
            {text}
          </TabLine>
        </Spacer>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

TabsLineList.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string,
      text: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
  modifiers: modifiersType,
  className: PropTypes.string,
};

TabsLineList.defaultProps = {
  tabs: [],
  modifiers: [],
  className: ''
};

export default TabsLineList;
